import React, { useEffect } from "react";

import SearchBar from "components/SearchBar";
import TierListLP from "./TierListLP";
import AdComponent from "components/Ads/AdComponent";

import { selectWinRate } from "api/data_parser/tier_list.js";
import { TIER_LIST_DEFAULT } from "query_parameters/filter_options";
import { useTierList } from "lib/hooks/tierlistHooks";

const LandingPageContainer = (props) => {
  const { className } = props;
  const { data, loading, error } = useTierList({ customParams: TIER_LIST_DEFAULT });

  const championWinRates = selectWinRate(data, TIER_LIST_DEFAULT);

  return (
    <div className={`landing-page-container_mobile ${className}`}>
      <img src={"https://static.bigbrain.gg/assets/ugg/images/pyke.svg"} width="100%" />
      <div className="all-landing-page-content">
        <div className={"content-side-padding-region"}>
          <div className="landing-header">
            <img className="ugg-logo" src={"https://static.bigbrain.gg/assets/ugg/logo/ugg-logo.svg"} alt="U.GG" />
            <h1 className="header">The best builds for all champions and elos.</h1>
          </div>
          <SearchBar
            searchDefault={" "}
            placeholder={"Search Class and Spec"}
            searchBarId="mobile-search-landing"
            autoFocus={false}
            isLandingMobile={true}
          />
          <div className="mobile-ad-container">
            <AdComponent slotId={"div-gpt-ad-ugg-10"} />
          </div>
          <TierListLP fetchingData={loading} tierData={championWinRates.role_win_rates} />
          <div className="mobile-ad-container">
            <AdComponent slotId={"div-gpt-ad-ugg-6"} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingPageContainer;
